export default __webpack_public_path__ + "static/backgroundDesktop@2x-381902a75aa985ca65b3386b5ba2dc4e.jpg";